import { Component, OnInit } from '@angular/core';
import { NavBarComponent } from '../nav-bar/nav-bar.component';
import { ActivatedRoute } from '@angular/router';
import { environment } from '../../environments/environment';

@Component({
  selector: 'app-registration-complete',
  templateUrl: './registration-complete.component.html',
  styleUrls: ['./registration-complete.component.css']
})
export class RegistrationCompleteComponent implements OnInit {
  navOptions = NavBarComponent.standard;
  email;
  constructor(private route:ActivatedRoute) { }

  ngOnInit() {
    this.email = this.route.snapshot.queryParams.email;
  }

  signIn(){
    window.location.href = `${environment.SITE_URL}/user/login`;
  }



}



// WEBPACK FOOTER //
// ./src/app/registration-complete/registration-complete.component.ts